module.exports = __webpack_public_path__ + "static/media/12x103.15b77f1e.png";